<div class="home-wrap">

  <!-- ╔══════ HERO ══════╗ -->
  <section class="hero">

    <div class="hero-text">
      <div class="hero-chip">🐾 Neural Architecture Showdown</div>

      <h1 class="hero-title">
        CON <span class="vs-text">-</span> KAN
      </h1>

      <p class="hero-desc">
        Explore how <strong>Kolmogorov–Arnold Networks</strong> challenge the
        reign of <strong>Convolutional Neural Networks</strong> on a classic
        <span class="hl-cat">Cat 🐱</span> vs <span class="hl-dog">Dog 🐶</span>
        classification task.
      </p>

      <div class="badge-row">
        <span class="badge b-purple">🔬 KAN</span>
        <span class="badge b-pink">🧠 CNN</span>
        <span class="badge b-mint">🐱 Cat</span>
        <span class="badge b-peach">🐶 Dog</span>
      </div>
    </div>

    <div class="hero-media">
      <!-- Replace with your own GIF / hosted image -->
      <img
        src="https://miro.medium.com/1*bhFifratH9DjKqMBTeQG5A.gif"
        alt="Cat and Dog"
        class="hero-gif"
       />
      <div class="hero-blob"></div>
    </div>

  </section>
  <!-- ╚══════════════════╝ -->

  <!-- ╔══════ ABOUT ══════╗ -->
  <section class="section">
    <h2 class="section-title"></h2>

    <div class="model-cards">

      <div class="mcard mcard-kan">
        <!-- <div class="mcard-top">
          <span class="mcard-icon">🔬</span>
          <h3>KAN</h3>
        </div>
        <p>
          <strong>Kolmogorov–Arnold Networks</strong> replace conventional
          node-level activation functions with <em>learnable, spline-based
          functions on edges</em>. Grounded in the Kolmogorov–Arnold
          representation theorem, KAN offers unprecedented interpretability
          alongside competitive accuracy.
        </p>
        <div class="mcard-tag">New Architecture · 2024</div> -->
        <!-- <img src="../../../modelcomparisonchart.png" alt="demo"/> -->
      </div>
      
      <div class="mcard mcard-cnn">
        <div class="mcard-top">
          <span class="mcard-icon">🧠</span>
          <h3>Why This Model ?</h3>
        </div>
        <p>
          <strong>Con-Kan</strong> As Compared to other models it ensures high Accuracy. This model utilizes the power image classification of CNN along with KAN's interpretability.
        </p>
        <div class="mcard-tag">Con-Kan = CNN + KAN</div>
      </div>




    </div>
  </section>
  <!-- ╚══════════════════╝ -->


  <h3 style="text-align: center;color:var(--blue);font-size: var(--radius-lg);">Explore the Parameters of The Model</h3>
   <!-- Parameters -->
  <section class="section bubble-container">

    <!-- Center Bubble -->
    <div class="bubble-center">
      Model Parameters
    </div>

    <!-- Small Floating Bubbles -->
    <div class="bubble-small b1">30 Epoch</div>
    <div class="bubble-small b2">Adam Optimizer</div>
    <div class="bubble-small b3">0.001 Learning Rate</div>
    <div class="bubble-small b4">3x3 Kernel</div>
    <div class="bubble-small b5">Stride 1</div>
    <div class="bubble-small b6">3 ConV</div>
    <div class="bubble-small b7">Cold Rolling</div>
    <div class="bubble-small b8">Digitalization</div>



  </section>


  <section class="section">
    <h2 class="section-title"></h2>

    <div class="model-cards">

      <div class="mcard mcard-cnn">
        <div class="mcard-top">
          <span class="mcard-icon">📉</span>
          <h3>Reduced Loss</h3>
        </div>
        <p>
          <strong>Less Loss</strong> Means more accurate model. This is achieved by the combination of CNN's feature extraction and KAN's learnable functions, which together optimize the learning process and minimize errors.
        </p>
        <div class="mcard-tag">Reduction in Loss by 10% compared to traditional models</div>
      </div>

      <div class="mcard mcard-loss">
        <!-- <div class="mcard-top">
          <span class="mcard-icon">🔬</span>
          <h3>KAN</h3>
        </div>
        <p>
          <strong>Kolmogorov–Arnold Networks</strong> replace conventional
          node-level activation functions with <em>learnable, spline-based
          functions on edges</em>. Grounded in the Kolmogorov–Arnold
          representation theorem, KAN offers unprecedented interpretability
          alongside competitive accuracy.
        </p>
        <div class="mcard-tag">New Architecture · 2024</div> -->
        <!-- <img src="../../../modelcomparisonchart.png" alt="demo"/> -->
      </div>




    </div>
  </section>

  <!-- ╔══════ ADVANTAGES ══════╗ -->
  <section class="section">
    <h2 class="section-title">✨ Advantages</h2>

    <div class="adv-grid">
      <div class="adv-card" *ngFor="let a of advantages" [style.background]="a.color">
        <span class="adv-icon">{{ a.icon }}</span>
        <h4>{{ a.title }}</h4>
        <p>{{ a.desc }}</p>
      </div>
    </div>
  </section>
  <!-- ╚══════════════════╝ -->
   

</div>